/**
 * Ids for rows, columns and elements.
 *
 * Not crypto, and they only have to be unique inside one document.
 * `crypto.randomUUID` is unavailable over plain http, which is how this app is
 * served in development, so the same counter-plus-timestamp shape the loyalty
 * rewards use is reused here.
 */
let sequence = 0

export function nextId(prefix: string): string {
  sequence += 1
  return `${prefix}-${Date.now().toString(36)}-${sequence}`
}
